import React, { useState } from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import { Box } from "@mui/system";
import { Toaster } from "react-hot-toast";

import Home from "./Home";
import Library from "./Library";
import AssetsPage from "./AssetsPage";
import ConnectWallet from "./ConnectWallet";
import Profile from "./Profile";
import Administration from "./Administration";
import Footer from "../components/Footer";
import Navigation from "../components/Navigation";
import NeedAuth from "../components/NeedAuth";

function RouterPages() {
    const [mobile] = useState(false);
    const {
        user: { account, isAdmin },
    } = useSelector((state) => state.user);
    const { pathname } = useLocation();

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "grid",
                gridTemplateRows: "calc(68px + 1.5rem) 1fr 80px",
                background: `${
                    pathname === "/"
                        ? "url(../assets/img/bg.png) center no-repeat"
                        : ""
                }`,
                backgroundSize: "cover",
                backgroundPositionY: "-50px",
                backgroundPositionX: "right",
            }}
        >
            <Toaster
                position="top-center"
                reverseOrder={false}
                toastOptions={{
                    className: "",
                    duration: 4000,
                    style: {
                        background: "#363636",
                        color: "#fff",
                    },
                    success: {
                        duration: 2000,
                        theme: {
                            primary: "green",
                            secondary: "black",
                        },
                    },
                }}
            />
            <Navigation mobile={mobile} account={account} isAdmin={isAdmin} />
            <Switch>
                <Route path={"/"} exact>
                    <Home />
                </Route>
                {/* <Route path="/" exact>
                    <Library />
                </Route> */}
                <Route path={"/connect"} exact>
                    <ConnectWallet />
                </Route>
                <Route path={"/library"}>
                    <Library />
                </Route>
                <Route path={"/contracts"}>
                    {account ? <AssetsPage account={account} /> : <NeedAuth />}
                </Route>
                {isAdmin && (
                    <Route path={"/administration"}>
                        <Administration />
                    </Route>
                )}
                <Route path={"/user"}>
                    <Profile />
                </Route>
                <Route path={"*"}>
                    <Redirect to="/" />
                </Route>
            </Switch>

            <Footer />
        </Box>
    );
}

export default RouterPages;
